import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  & > p {
    font: ${props => props.theme.fontWeightBold} 21px/120% ${props => props.theme.fontFamilyBody};
    margin: 0;
    color: ${props => props.theme.bodyColor};
  }

  & > .text {
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0.1px;
    color: ${props => props.theme.secondaryColor};

    > .regular {
      margin-top: 3px;
      font-weight: ${props => props.theme.fontWeightRegular};
    }

    > .bold {
      margin: 16px 0 0 0;
      font-weight: ${props => props.theme.fontWeightBold};
    }
  }
`;

export default function Name({ name, perfUpdateDate }) {
  return (
    <Container>
      <p>{name}</p>
      <div className="text">
        <p className="regular">{`Trailing month end returns as of ${perfUpdateDate}`}</p>
        <p className="bold">Performance after fees, including distributions or dividends paid</p>
      </div>
    </Container>
  );
}

Name.propTypes = {
  name: PropTypes.string.isRequired,
  perfUpdateDate: PropTypes.string.isRequired,
};
